module.exports = __webpack_public_path__ + "img/dynamic-27 - 副本.246cbdd9.png";